import {Fragment, PropsWithChildren, ReactElement} from "react"
import {Form, Input, InputNumber, Radio} from "antd"
import {TBoatTracking} from "@ui/api/user"
import {t} from "@ui/common/intl"
import {BoatInfoHeader, TBoatInfoPageProps} from "./common"

type TTrackingItemProps = {
  classname?: string
  prop: keyof TBoatTracking
  onShowHint?: (key: keyof TBoatTracking) => void
  maxLength?: number
}
const TrackingItem = ({prop, onShowHint, children, classname}: TTrackingItemProps & PropsWithChildren): ReactElement => {
  return (
    <Form.Item<TBoatTracking> label={t(`profile.boat.${prop}.title`)}>
      <Form.Item<TBoatTracking> name={prop} className={classname}>
        {children}
      </Form.Item>
      {onShowHint && (
        <div>
          <div className="hint" onClick={() => onShowHint(prop)}>
            {t(`profile.boat.${prop}.hint.title`)}
          </div>
        </div>
      )}
    </Form.Item>
  )
}

const TrackingInput = ({prop, onShowHint, maxLength}: TTrackingItemProps): ReactElement => {
  const placeholder = t(`profile.boat.${prop}.placeholder`)
  return (
    <TrackingItem prop={prop} onShowHint={onShowHint}>
      {maxLength
        ? <Input allowClear maxLength={maxLength} placeholder={placeholder} />
        : <InputNumber min={1} placeholder={placeholder} />
      }
    </TrackingItem>
  )
}

const TrackingRadio = ({prop, onShowHint}: TTrackingItemProps): ReactElement => {
  return (
    <TrackingItem prop={prop} onShowHint={onShowHint} classname="tracking-radio">
      <Radio.Group
        options={[
          {value: true, label: t("yes")},
          {value: false, label: t("no")}
        ]}
      />
    </TrackingItem>
  )
}

const Tracking = ({form, onShowHint}: TBoatInfoPageProps): ReactElement => {
  const has_ais = Form.useWatch("has_ais", form);

  return (
    <Fragment>
      <BoatInfoHeader title={t("profile.boat.info.tracking.header")} />
      <TrackingRadio prop="has_ais" onShowHint={onShowHint} />
      {has_ais && <TrackingInput prop="mmsi" onShowHint={onShowHint} />}
      <TrackingInput prop="dest_port" maxLength={200} />
    </Fragment>
  )
}

export default Tracking
